/* eslint-disable no-console */
export default class GS1BarcodeParser {
  // public static readonly string[] GS1Symbology = new string[] { "]C0", "]C1", "]e0", "]e1", "]e2", "]d2", "]Q3" };

  // convert the above to Javascript
  static GS1Symbology = ["]C0", "]C1", "]e0", "]e1", "]e2", "]d2", "]Q3"];

  static DYNAMIC_FIELD_END_SYMBOL = "Alt0029";
  // private readonly string[] GS1SymbologyNames = new string[] { "GS1-128", "GS1 Databar", "GS1 Composite Symbols", "GS1 Composite Symbols", "GS1 DataMatrix", "GS1 QR Code" };

  // convert the above to Javascript
  static GS1SymbologyNames = [
    "GS1-128",
    "GS1 Databar",
    "GS1 Composite Symbols",
    "GS1 Composite Symbols",
    "GS1 DataMatrix",
    "GS1 QR Code",
  ];

  constructor() {
    this.barcode = "";
    this.currentPosition = 0;
    this.gs1Barcode = {};
  }

  parse() {
    if (!this.barcode) {
      return false;
    }

    this.currentPosition = 0;
    // GS1 Barcode validation will fail when appropriate identifier is not found
    // therefore we are getting rid of this Symbology validation
    // if (!this.isValidSymbology()) {
    //   return false;
    // }
    // console.log("Symbology is valid");

    this.gs1Barcode = {
      barcode: this.barcode.substring(this.currentPosition),
    };
    this.barcode = this.gs1Barcode.barcode;
    this.currentPosition = 0;

    // Remove escape character
    this.barcode = this.barcode.replace(/\\[ntr]/g, "");

    console.log("Barcode after removing escape characters: ", this.barcode);
    // this.barcode = this.barcode.replace(/\x1d/g, "");

    if (this.barcode.includes("(")) {
      return this.processIdentifiersWithBrackets();
    } else {
      console.log("Barcode does not include (");
      console.log("Current position: ", this.currentPosition);
      console.log("Barcode length: ", this.barcode.length);

      while (this.currentPosition < this.barcode.length) {
        const applicationId = this.barcode.substring(
          this.currentPosition,
          this.currentPosition + 2
        );

        console.log("Application ID: ", applicationId);

        this.currentPosition += 2;
        let minLength, maxLength;

        switch (applicationId) {
          case "00":
            {
              minLength = 18;
              maxLength = 18;
              const val = this.getBarcodeSectionAsLong(minLength, maxLength);

              this.gs1Barcode.serialShippingContainerCodeSSCC18 =
                val === null ? null : val.toString();
            }
            break;

          case "01":
            {
              minLength = 14;
              maxLength = 14;
              const val = this.getBarcodeSectionAsLong(minLength, maxLength);
              this.gs1Barcode.shippingContainerCodeSSC =
                val === null ? null : val.toString();
            }
            break;

          case "02":
            {
              minLength = 14;
              maxLength = 14;
              const val = this.getBarcodeSectionAsLong(minLength, maxLength);
              this.gs1Barcode.gtin = val === null ? null : val.toString();
              console.log("GTIN: ", this.gs1Barcode.gtin);
            }
            break;

          case "10":
            minLength = 1;
            maxLength = 20;
            // this.gs1Barcode.batchNumber = this.getBarcodeSection(
            //   minLength,
            //   maxLength
            // );

            this.gs1Barcode.batchNumber = this.getVariableLengthSection();

            break;

          case "11":
            minLength = 6;
            maxLength = 6;
            this.gs1Barcode.productionDate = this.getBarcodeSectionAsDate(
              minLength,
              maxLength
            );
            break;

          case "13":
            minLength = 6;
            maxLength = 6;
            this.gs1Barcode.packagingDate = this.getBarcodeSectionAsDate(
              minLength,
              maxLength
            );
            break;

          case "17":
            minLength = 6;
            maxLength = 6;
            this.gs1Barcode.expirationDate = this.getBarcodeSectionAsDate(
              minLength,
              maxLength
            );
            break;

          case "24":
            minLength = 1;
            maxLength = 30;
            this.currentPosition += 1;
            this.gs1Barcode.additionalProductIdentification =
              this.getBarcodeSection(minLength, maxLength);
            break;

          case "37":
            minLength = 1;
            maxLength = 29;
            // this.gs1Barcode.numberOfUnitsContained =
            //   this.getBarcodeSectionAsLong(minLength, maxLength);

            this.gs1Barcode.numberOfUnitsContained =
              this.getVariableLengthSectionAsLong();
            break;

          // ... (other cases similar to C# code)

          case "99":
            minLength = 1;
            maxLength = 30;
            this.gs1Barcode.companyInternalInformation9 =
              this.getBarcodeSection(minLength, maxLength);
            break;

          default:
            return false;
        }
      }

      return true;
    }
  }

  getVariableLengthSectionAsLong() {
    const barcodeSection = this.getVariableLengthSection();
    if (!barcodeSection) {
      return null;
    }
    return parseInt(barcodeSection, 10);
  }

  getVariableLengthSection() {
    let endIndex = this.barcode.indexOf(
      GS1BarcodeParser.DYNAMIC_FIELD_END_SYMBOL,
      this.currentPosition
    );

    if (endIndex < 0) {
      endIndex = this.barcode.length;
    }

    const barcodeSection = this.barcode.substring(
      this.currentPosition,
      endIndex
    );

    this.currentPosition =
      endIndex + GS1BarcodeParser.DYNAMIC_FIELD_END_SYMBOL.length;

    return barcodeSection;
  }

  getBarcodeSectionAsLongWithIdentifier(identifier) {
    const barcodeSection =
      this.getBarcodeSectionAsStringWithIdentifier(identifier);
    if (!barcodeSection) {
      return null;
    }
    return parseInt(barcodeSection, 10);
  }

  getBarcodeSectionAsStringWithIdentifier(identifier) {
    const identifierWithBrackets = `(${identifier})`;
    const index = this.barcode.indexOf(identifierWithBrackets);

    if (index >= 0) {
      const startCharacterIndex = index + identifierWithBrackets.length;
      const remainderOfBarcode = this.barcode.substring(startCharacterIndex);
      const nextBracketIndex = remainderOfBarcode.indexOf("(");
      return nextBracketIndex >= 0
        ? remainderOfBarcode.substring(0, nextBracketIndex)
        : remainderOfBarcode;
    }

    return null;
  }
  getBarcodeSectionAsDate(minLength, maxLength) {
    const barcodeSection = this.getBarcodeSection(minLength, maxLength);

    // barcode section should be 6 characters long
    // format YYMMDD
    if (!barcodeSection || barcodeSection.length !== 6) {
      return null;
    }

    const year = parseInt(barcodeSection.substring(0, 2), 10) + 2000;
    const month = parseInt(barcodeSection.substring(2, 4), 10) - 1; // JavaScript months are 0-indexed
    const day = parseInt(barcodeSection.substring(4, 6), 10);

    return new Date(year, month, day);
  }

  getBarcodeSectionAsDateWithIdentifier(identifier) {
    const barcodeSection =
      this.getBarcodeSectionAsStringWithIdentifier(identifier);
    if (!barcodeSection || barcodeSection.length !== 6) {
      return null;
    }

    const year = parseInt(barcodeSection.substring(0, 2), 10) + 2000;
    const month = parseInt(barcodeSection.substring(2, 4), 10) - 1; // JavaScript months are 0-indexed
    const day = parseInt(barcodeSection.substring(4, 6), 10);

    return new Date(year, month, day);
  }

  processIdentifiersWithBrackets() {
    this.gs1Barcode.serialShippingContainerCodeSSCC18 =
      this.getBarcodeSectionAsLongWithIdentifier("00");
    this.gs1Barcode.shippingContainerCodeSSC =
      this.getBarcodeSectionAsStringWithIdentifier("01");
    this.gs1Barcode.gtin = this.getBarcodeSectionAsLongWithIdentifier("02");
    this.gs1Barcode.batchNumber =
      this.getBarcodeSectionAsStringWithIdentifier("10");
    this.gs1Barcode.productionDate =
      this.getBarcodeSectionAsDateWithIdentifier("11");
    this.gs1Barcode.packagingDate =
      this.getBarcodeSectionAsDateWithIdentifier("13");
    this.gs1Barcode.sellByDateQualityControl =
      this.getBarcodeSectionAsDateWithIdentifier("15");
    this.gs1Barcode.expirationDate =
      this.getBarcodeSectionAsDateWithIdentifier("17");
    this.gs1Barcode.productVariant =
      this.getBarcodeSectionAsLongWithIdentifier("20");
    this.gs1Barcode.serialNumber =
      this.getBarcodeSectionAsStringWithIdentifier("21");
    this.gs1Barcode.hibccQuantityDateBatchAndLink =
      this.getBarcodeSectionAsStringWithIdentifier("22");
    this.gs1Barcode.lotNumber =
      this.getBarcodeSectionAsStringWithIdentifier("23");
    this.gs1Barcode.additionalProductIdentification =
      this.getBarcodeSectionAsStringWithIdentifier("240");
    this.gs1Barcode.secondSerialNumber =
      this.getBarcodeSectionAsStringWithIdentifier("25");
    this.gs1Barcode.quantityEach =
      this.getBarcodeSectionAsLongWithIdentifier("30");
    this.gs1Barcode.numberOfUnitsContained =
      this.getBarcodeSectionAsLongWithIdentifier("37");
    this.gs1Barcode.customerPurchaseOrderNumber =
      this.getBarcodeSectionAsStringWithIdentifier("40");
    this.gs1Barcode.mutuallyAgreedBetweenTradingPartners =
      this.getBarcodeSectionAsStringWithIdentifier("90");
    this.gs1Barcode.companyInternalInformation =
      this.getBarcodeSectionAsStringWithIdentifier("91");
    this.gs1Barcode.companyInternalInformation2 =
      this.getBarcodeSectionAsStringWithIdentifier("92");
    this.gs1Barcode.companyInternalInformation3 =
      this.getBarcodeSectionAsStringWithIdentifier("93");
    this.gs1Barcode.companyInternalInformation4 =
      this.getBarcodeSectionAsStringWithIdentifier("94");
    this.gs1Barcode.companyInternalInformation5 =
      this.getBarcodeSectionAsStringWithIdentifier("95");
    this.gs1Barcode.companyInternalInformation6 =
      this.getBarcodeSectionAsStringWithIdentifier("96");
    this.gs1Barcode.companyInternalInformation7 =
      this.getBarcodeSectionAsStringWithIdentifier("97");
    this.gs1Barcode.companyInternalInformation8 =
      this.getBarcodeSectionAsStringWithIdentifier("98");
    this.gs1Barcode.companyInternalInformation9 =
      this.getBarcodeSectionAsStringWithIdentifier("99");

    return true;
  }

  //   private string GetBarcodeSection(int minLength, int maxLength)
  //         {
  //             if (this.Barcode.Length < this.currentPosition + minLength)
  //             {
  //                 // error not enough room in the barcode to read this string
  //             }

  //             if (this.Barcode.Length < this.currentPosition + maxLength)
  //             {
  //                 // last field is variable length
  //                 // currently only support last field being mixed length
  //                 maxLength = this.Barcode.Length - this.currentPosition;
  //             }

  //             string barcodeSection = this.Barcode.Substring(this.currentPosition, maxLength);
  //             currentPosition += barcodeSection.Length;
  //             return barcodeSection;
  //         }

  getBarcodeSection(minLength, maxLength) {
    if (this.barcode.length < this.currentPosition + minLength) {
      // error not enough room in the barcode to read this string
    }

    if (this.barcode.length < this.currentPosition + maxLength) {
      // last field is variable length
      // currently only support last field being mixed length
      maxLength = this.barcode.length - this.currentPosition;
    }

    console.log(
      "getBarcodeSection Current position:  ",
      this.currentPosition,
      maxLength
    );

    // c# subsctring method to javascript substring method

    const barcodeSection = this.barcode.substring(
      this.currentPosition,
      this.currentPosition + maxLength
    );
    this.currentPosition += barcodeSection.length;

    console.log(
      "getBarcodeSection Current position after:  ",
      this.currentPosition
    );
    console.log("getBarcodeSection Barcode section:  ", barcodeSection);
    return barcodeSection;
  }

  isValidSymbology() {
    if (!this.barcode || this.barcode.length < 3) {
      return false;
    }

    const symbology = this.barcode.substring(0, 3);

    console.log("Symbology: ", symbology);

    this.currentPosition = 3;
    for (let i = 0; i < GS1BarcodeParser.GS1Symbology.length; i++) {
      if (GS1BarcodeParser.GS1Symbology[i] === symbology) {
        console.log(`Found Symbology ${GS1BarcodeParser.GS1SymbologyNames[i]}`);
        return true;
      }
    }

    return false;
  }

  getBarcodeSectionAsLong(minLength, maxLength) {
    console.log(
      "getBarcodeSectionAsLong Current position:  ",
      this.currentPosition
    );
    console.log(
      "getBarcodeSectionAsLong Barcode length:  ",
      this.barcode.length,
      minLength,
      maxLength
    );

    return this.getBarcodeSectionAsLongWiCheckDigit(
      minLength,
      maxLength,
      false
    );
  }

  getBarcodeSectionAsLongWiCheckDigit(minLength, maxLength, hasCheckDigit) {
    let barcodeSection;
    if (hasCheckDigit) {
      barcodeSection = this.getBarcodeSection(minLength, maxLength);
      barcodeSection = barcodeSection.substring(0, barcodeSection.length - 1);
    } else {
      barcodeSection = this.getBarcodeSection(minLength, maxLength);
    }

    console.log("Barcode section: ", barcodeSection);

    let result = 0;

    try {
      result = parseInt(barcodeSection, 10);
    } catch {
      result = 0;
    }

    return result;
  }

  // Additional methods like isValidSymbology(), getBarcodeSection(), getBarcodeSectionAsLong(), etc.
  // would need to be implemented similarly to their C# counterparts
}

// Usage example:
// const parser = new GS1BarcodeParser();
// const anotherLabel = "]C100093423690001819528";
// const gs1Label = "]C10109342369000774132408191097677";
// const gs1Label2 = "]C1(02)09342369000156(37)80(13)240815(10)97649C(240)12";
// const lachyTestBarcode1 = "0109342369000774132408191097677";
// const lachyTestBarcode2 =
//   "02093423690001563780Alt0029132408151097649CAlt002924012";
// const lachyTestBarcode3 = "02093423690001563780132408151097649C24012"; // "02093423690001563780132408151097649C24012";
// parser.barcode = lachyTestBarcode2;
// const success = parser.parse();
// if (success) {
//   // eslint-disable-next-line no-console
//   console.log(parser.gs1Barcode);
// } else {
//   // eslint-disable-next-line no-console
//   console.log("Failed to parse barcode");
// }

// console.log(
//   "shippingContainerCodeSSC",
//   parser.gs1Barcode.shippingContainerCodeSSC
// );

// console.log(
//   "serialShippingContainerCodeSSCC18",
//   parser.gs1Barcode.serialShippingContainerCodeSSCC18
// );

// console.log("gtin", parser.gs1Barcode.gtin);
